module.exports = __webpack_public_path__ + "img/vali-icon.a1f05ec7.svg";